export const businessIntelligenceMarketAnalysis = {
  name: "Análise de Mercado |||| Análise de Mercado",
};

export const businessIntelligenceSales = {
  name: "Vendas |||| Vendas",
};

export const businessIntelligenceGeographicAnalysis = {
  name: "Análise Geográfica |||| Análise Geográfica",
};

export const businessIntelligencePipelineAnalysis = {
  name: "Análise de Pipeline |||| Análise de Pipeline",
};

export const businessIntelligenceIrt = {
  name: "IRT |||| IRT",
};
